export function parseSketch(layout: LayoutSketch): LayoutMatrix {
  return layout.map(s => {
    return s.split("").map(c => c === "#");
  });
}

export function drawSketch(layout: LayoutMatrix): LayoutSketch {
  return layout.map(a => {
    return a.map(b => b ? "#" : " ").join("");
  });
}

export type LayoutMatrix = boolean[][];
export type LayoutSketch = string[];

export interface Point {
  x: number;
  y: number;
}
